import React from 'react';

import ModalBase from './ModalBase';
import ModalHeader from './ModalHeader';
import ModalContent from './ModalContent';
import TModalBase from './@types/TModalBase';
import TModalHeader from './@types/TModalHeader';
import TBasicModal from './@types/TBasicModal';

const BasicModal = ({
  title,
  children,
  onClose,
  onBack,
  contentClassName,
  isBottomSheet,
  ...rest
}: TModalBase & TModalHeader & TBasicModal) => (
  <ModalBase kind={isBottomSheet ? 'bottom-sheet' : 'basic'} onClose={onClose} {...rest}>
    <ModalHeader onClose={onClose} title={title} onBack={onBack} />
    <ModalContent className={contentClassName}>{children}</ModalContent>
  </ModalBase>
);

export default BasicModal;
